const devicesList = {
  bindings: {
    assets: '<',
    subsystem: '<',
    onSelect: '&',
  },
  templateUrl:
    '/modules/modals/subsystem-modal/devices-list/devices-list.html',
  controller: 'DevicesListController',
};

angular
  .module('modalDirectives')
  .component('devicesList', devicesList);
